/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_IncompleteInputs */

const zh_status_incomplete = /** @type {(inputs: Status_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未完成`)
};

const en_status_incomplete = /** @type {(inputs: Status_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incomplete`)
};

const es_status_incomplete = /** @type {(inputs: Status_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incompleto`)
};

/**
* | output |
* | --- |
* | "Incomplete" |
*
* @param {Status_IncompleteInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_incomplete = /** @type {((inputs?: Status_IncompleteInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_IncompleteInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_status_incomplete(inputs)
	if (locale === "en") return en_status_incomplete(inputs)
	return es_status_incomplete(inputs)
});